export default {
  // フッター
  TERMS_OF_SERVICE: "使用條款",
  PRIVACY_POLICY: "隱私政策",
  COMPANY_INFORMATION: "企業資訊",
  MAILORDERLAW_DETAILS: "依據特定商業交易法的顯示",
  ATAMI_CITY_TOURISM_ASSOCIATION: "熱海市觀光協會 (Atami City Tourism Association)",
};
